import {
    Controller,
    IDynamicLoader,
    Loader,
    Toolbar,
    MainMenu, Menu, ActionPointInfo, IActionPointInfo,
} from '@tencent/workbench';
import { TOOLBAR_ITEMS, config, MENU_CONFIGS, toolbarConfig } from './config';
import {
    TransitionEffectOptionFeature,
} from '@framework/workbench/ui/transition/transition-effect-option/transition-effect-option-feature';
import React from 'react';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class TransitionEffectOptionController {
    public constructor(@Loader(TransitionEffectOptionFeature) private loader: IDynamicLoader<
        TransitionEffectOptionFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(toolbarConfig.id, 'icon')
    public getIconContent() {
        return this.feature.getIcon();
    }

    @Toolbar(toolbarConfig.id, 'dropdownContent')
    public insertDropdown() {
        const menuId = this.getTransitionMenuId();
        return <MainMenu
            align="left" name={menuId} mode="menu" itemStyle={{ width: 200 }} />;
    }

    @Toolbar(toolbarConfig.id, 'shouldDisabled')
    public shouldDisable(@ActionPointInfo() info:  IActionPointInfo) {
        return this.feature.shouldDisabled(config.id);
    }

    @Menu(ActionType.TRANSITION_EFFECT_FADE_SMOOTH, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_FADE_BLACK, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PUSH_BOTTOM, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PUSH_LEFT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PUSH_RIGHT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PUSH_TOP, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_SWITCH_LEFT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_SWITCH_RIGHT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_CUT_NONE, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_CUT_BLACK, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_RIGHT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_TOP, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_LEFT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_BOTTOM, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_RIGHT_UP, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_RIGHT_DOWN, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_LEFT_UP, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_LEFT_DOWN, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_RIGHT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_TOP, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_LEFT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_BOTTOM, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_RIGHT_UP, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_RIGHT_DOWN, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_LEFT_DOWN, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_LEFT_UP, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_WARP_ENLARGE, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_WARP_NARROW, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_NEWSFLASH, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_FLIP_RIGHT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_FLIP_LEFT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_GALLERY_RIGHT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_GALLERY_LEFT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PRISM_BOTTOM, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PRISM_TOP, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PRISM_LEFT, 'shouldCheck')
    @Menu(ActionType.TRANSITION_EFFECT_PRISM_RIGHT, 'shouldCheck')
    public topMenuShouldCheck(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;

        if (name) {
            const effectOption = this.feature.getTransitionEffect();
            return name === effectOption?.id;
        }

        return false;
    }

    @Menu(ActionType.TRANSITION_EFFECT_FADE_SMOOTH, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_FADE_BLACK, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_CUT_NONE, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_CUT_BLACK, 'onClick')
    public handleThroughBlackEffectClick(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;
        this.feature.updateThroughBlack(name);
    }

    @Menu(ActionType.TRANSITION_EFFECT_PUSH_BOTTOM, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PUSH_LEFT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PUSH_RIGHT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PUSH_TOP, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PRISM_BOTTOM, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PRISM_TOP, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PRISM_LEFT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PRISM_RIGHT, 'onClick')
    public handleSideDirectionEffectClick(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;
        this.feature.updateSideDirection(name);
    }

    @Menu(ActionType.TRANSITION_EFFECT_SWITCH_LEFT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_SWITCH_RIGHT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_FLIP_RIGHT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_FLIP_LEFT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_GALLERY_RIGHT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_GALLERY_LEFT, 'onClick')
    public handleSwitchDirectionEffectClick(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;
        this.feature.updateSwitchDirection(name);
    }

    @Menu(ActionType.TRANSITION_EFFECT_PULL_RIGHT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_TOP, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_LEFT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_BOTTOM, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_RIGHT_UP, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_RIGHT_DOWN, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_LEFT_UP, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_PULL_LEFT_DOWN, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_RIGHT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_TOP, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_LEFT, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_BOTTOM, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_RIGHT_UP, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_RIGHT_DOWN, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_LEFT_DOWN, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_COVER_LEFT_UP, 'onClick')
    public handleEightDirectionEffectClick(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;
        this.feature.updateEightDirection(name);
    }

    @Menu(ActionType.TRANSITION_EFFECT_WARP_ENLARGE, 'onClick')
    @Menu(ActionType.TRANSITION_EFFECT_WARP_NARROW, 'onClick')
    public handleInoutDirectionEffectClick(@ActionPointInfo() info:  IActionPointInfo) {
        const { name } = info;
        this.feature.updateInOutDirection(name);
    }

    @Menu(ActionType.TRANSITION_EFFECT_NEWSFLASH, 'onClick')
    public handleNewsflashEffectClick(@ActionPointInfo() info:  IActionPointInfo) {
        this.feature.updateNewsflash();
    }

    private getTransitionMenuId() {
        let type = this.feature.currentTransitionType;

        // newsflash 是 warp 菜单下的一种效果，但是独立除了一种type
        if (type === TransitionType.NEWSFLASH) {
            type = TransitionType.WARP;
        }

        return  `transition-effect-${type}-menu`;
    }
}
